export interface ExpenseDraft {
  date: string;
  description: string;
  categoryId: string;
  amount: string;
  paymentMethod: string;
  notes: string;
}

export interface ValidationResult {
  valid: boolean;
  errors: Record<string, string>;
}

export function validateExpense(draft: ExpenseDraft): ValidationResult {
  const errors: Record<string, string> = {};

  if (!draft.description.trim()) {
    errors.description = "La descripción es obligatoria.";
  }
  if (!draft.date) {
    errors.date = "Selecciona una fecha válida.";
  }
  if (!draft.categoryId) {
    errors.categoryId = "Selecciona una categoría.";
  }
  const amount = parseFloat(draft.amount);
  if (!draft.amount || isNaN(amount) || amount <= 0) {
    errors.amount = "El importe debe ser mayor que 0.";
  }
  if (!draft.paymentMethod) {
    errors.paymentMethod = "Selecciona un método de pago.";
  }

  return { valid: Object.keys(errors).length === 0, errors };
}

export function isValidDate(value: string): boolean {
  if (!value) return false;
  const d = new Date(value);
  return !isNaN(d.getTime());
}